


























































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* components */
import DoughnutGraph from '@/app/components/Profit/DoughnutGraph.vue'
import PieGraph from '@/app/components/Profit/PieGraph.vue'
import ProfitListHeader from '@/app/components/Profit/ProfitListHeader.vue'
import ProfitList from '@/app/components/Profit/ProfitList.vue'
/* plugin */
import * as ChartDatalabels from 'chartjs-plugin-datalabels'
import CommonClass from '@/app/module/common'

let totalIncome: number = 0

@Component({
  components: {
    DoughnutGraph,
    PieGraph,
    ProfitListHeader,
    ProfitList
  }
})
export default class Profit extends Vue {
  /* 表示切り替え */
  private showBalloon: boolean = true
  private allGraphData: boolean = false
  private areaGraphData: boolean = false
  private factorGraphData: boolean = false
  /* データ */
  private displayListData: any = []
  private checked: string = '全情報'
  private notFoundMessage: boolean = false
  public allChartData: any = {}
  public vrietyIncomeData: any = {}
  public groupIncomeData: any = {}
  public allChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    layout: {
      padding: {
        top: 20,
        left: 0,
        bottom: 20,
        right: 20
      }
    },
    tooltips: {
      enabled: false
    },
    plugins: [
      ChartDatalabels
    ]
  }
  public vrietyIncomeOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul>')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].fillStyle + '"></span><span>')
        if (chart.legend.legendItems[i]) {
          text.push(CommonClass.stringCut(chart.legend.legendItems[i].text) + '（' + CommonClass.checkLength(chart.data.datasets[0].data[i]) + '円）')
        }
        text.push('</span></li>')
      }
      text.push('</ul>')

      return 1 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 0,
        bottom: 20,
        right: 20
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any, data: any) {
          return data.labels[tooltipItem.index] +
                ': ' +
                CommonClass.checkLength(data.datasets[0].data[tooltipItem.index]) +
                '円'
        }
      }
    }
  }
  public groupIncomeOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul>')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].fillStyle + '"></span><span>')
        if (chart.legend.legendItems[i]) {
          text.push(CommonClass.stringCut(chart.legend.legendItems[i].text) + '（' + CommonClass.checkLength(chart.data.datasets[0].data[i]) + '円）')
        }
        text.push('</span></li>')
      }
      text.push('</ul>')

      return 2 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 0,
        bottom: 20,
        right: 20
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any, data: any) {
          return data.labels[tooltipItem.index] +
                ': ' +
                CommonClass.checkLength(data.datasets[0].data[tooltipItem.index]) +
                '円'
        }
      }
    }
  }
  // 内側の文字
  private textInChart: any = {
    beforeDraw: function (chart: any) {
      if (totalIncome !== 0 && totalIncome !== null) {
        var width = chart.chart.width
        var height = chart.chart.height
        var ctx = chart.chart.ctx

        ctx.restore()
        // 文字
        ctx.font = '15px sans-serif'
        ctx.textBaseline = 'middle'
        var text = '全体圃場収入'
        var textX = Math.round((width - ctx.measureText(text).width) / 2)
        var textY = height / 2 - 10
        ctx.fillText(text, textX, textY)

        ctx.font = 'bold 22px sans-serif'
        var text2 = CommonClass.checkLength(totalIncome) + '円'
        var textX2 = Math.round((width - ctx.measureText(text2).width) / 2)
        var textY2 = height / 2 + 15
        ctx.fillText(text2, textX2, textY2)
        ctx.save()
      }
    }
  }

  @Prop() graphData!: any
  @Prop() listData!: any

  /* computed */
  private get checkedLossFactor () {
    return this.checked
  }
  @Watch('checkedLossFactor')
  onRadioChange (val: string) {
    this.refineList(val)
  }

  created () {
    this.displayListData = this.listData
    this.createGraphData()

    totalIncome = this.graphData.total_field_income
  }

  /* 円グラフデータ作成 */
  public createGraphData () {
    // 等級内訳
    this.allChartData = {
      labels: this.createGradeLabel(),
      datasets: [
        {
          data: this.createGradeData(),
          backgroundColor: ['#FCEFE4', '#F5F5F5'],
          datalabels: {
            enabled: true,
            color: ['#E86161', '#2C2C2C'],
            textAlign: 'center',
            font: {
              size: '20',
              weight: 'bold'
            },
            formatter: function (value: any, ctx: any) {
              if (value !== 0 && value !== null) {
                var index = ctx.dataIndex
                var label = ctx.chart.data.labels[index]
                return label + '\n' + CommonClass.checkLength(value) + '円'
              } else {
                return ''
              }
            }
          }
        }
      ]
    }

    // 品種内訳
    this.vrietyIncomeData = {
      labels: this.createVrietyIncomeLabel(),
      datasets: [
        {
          data: this.createVrietyIncomeData(),
          backgroundColor: ['#FCEFE4', '#EAFCE4', '#E4F9FC', '#F5F5F5'],
          borderWidth: 0,
          datalabels: {
            color: '#2C2C2C',
            textAlign: 'center',
            labels: {
              title: {
                font: {
                  weight: 'bold',
                  size: 13
                }
              }
            },
            formatter: (value: any, ctx: any) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map((data: any) => {
                sum += data
              })
              let percentage = (value * 100 / sum)

              if (percentage > 5) {
                return percentage.toFixed(0) + '%'
              } else {
                return ''
              }
            }
          }
        }
      ]
    }

    // グループ内訳
    this.groupIncomeData = {
      labels: this.createGroupIncomeLabel(),
      datasets: [
        {
          data: this.createGroupIncomeData(),
          backgroundColor: ['#FCEFE4', '#EAFCE4', '#E4F9FC', '#F0E4FC', '#F5F5F5'],
          borderWidth: 0,
          datalabels: {
            color: '#2C2C2C',
            textAlign: 'center',
            labels: {
              title: {
                font: {
                  weight: 'bold',
                  size: 13
                }
              }
            },
            formatter: (value: any, ctx: any) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map((data: any) => {
                sum += data
              })
              let percentage = (value * 100 / sum)

              if (percentage > 5) {
                return percentage.toFixed(0) + '%'
              } else {
                return ''
              }
            }
          }
        }
      ]
    }
  }

  /* 等級内訳ラベル  */
  private createGradeLabel () {
    let gradeLoss = this.graphData.grade_income
    let gradeLabel = []

    for (var i in gradeLoss) {
      if (gradeLoss[i].grade_price !== 0 && gradeLoss[i].grade_price !== null) {
        gradeLabel.push(gradeLoss[i].grade_name + '等級')
      }
    }

    if (gradeLabel.length === 0) {
      this.allGraphData = true
    }

    return gradeLabel
  }

  /* 等級内訳データ */
  private createGradeData () {
    let gradeLoss = this.graphData.grade_income
    let gradeData = []

    for (var i in gradeLoss) {
      gradeData.push(gradeLoss[i].grade_price)
    }

    gradeLoss.sort(
      function (a:number, b: number) {
        return b - a
      }
    )

    if (gradeData.length === 0) {
      this.allGraphData = true
    }

    return gradeData
  }

  /* 品種内訳ラベル */
  private createVrietyIncomeLabel () {
    let vrietyLoss = this.graphData.vriety_income
    let vrietyLossLabel = []

    for (var i in vrietyLoss) {
      if (vrietyLoss[i].vriety_price !== 0 && vrietyLoss[i].vriety_price !== null) {
        vrietyLossLabel.push(vrietyLoss[i].vriety_name)
      }
    }

    if (vrietyLossLabel.length === 0) {
      this.areaGraphData = true
    }

    return vrietyLossLabel
  }

  /* 品種内訳データ */
  private createVrietyIncomeData () {
    let vrietyLoss = this.graphData.vriety_income
    let vrietyLossData = []

    for (var i in vrietyLoss) {
      vrietyLossData.push(vrietyLoss[i].vriety_price)
    }

    vrietyLossData.sort(
      function (a:number, b: number) {
        return b - a
      }
    )

    if (vrietyLossData.length === 0) {
      this.areaGraphData = true
    }

    return vrietyLossData
  }

  /* グループ内訳ラベル */
  private createGroupIncomeLabel () {
    let groupLoss = this.graphData.group_income
    let groupLossLabel = []

    for (var i in groupLoss) {
      if (groupLoss[i].group_price !== 0 && groupLoss[i].group_price !== null) {
        groupLossLabel.push(groupLoss[i].group_name)
      }
    }

    if (groupLossLabel.length === 0) {
      this.factorGraphData = true
    }

    return groupLossLabel
  }

  /* 欠損要因データ */
  private createGroupIncomeData () {
    let groupLoss = this.graphData.group_income
    let groupLossData = []

    for (var i in groupLoss) {
      groupLossData.push(groupLoss[i].group_price)
    }

    groupLossData.sort(
      function (a:number, b: number) {
        return b - a
      }
    )

    if (groupLossData.length === 0) {
      this.factorGraphData = true
    }

    return groupLossData
  }

  /* リスト絞り込み */
  private refineList (val: string) {
    this.displayListData = []

    if (val === '全情報') {
      this.displayListData = this.listData
    }

    for (var i in this.listData) {
      if (this.listData[i].grade === parseInt(val)) {
        this.displayListData.push(this.listData[i])
      }
    }

    if (this.displayListData.length === 0) {
      this.notFoundMessage = true
    } else {
      this.notFoundMessage = false
    }
  }
}
